import React, {memo} from "react";
import PropTypes from "prop-types";
import {NavLink as NavLinkRRD, useLocation} from "react-router-dom";
import {NavLink} from "reactstrap";

/** This component will create link to be displayed on sidebar */

const NormalLink = (props) => {
  const {
    activeRouteOptions = [],
    layout,
    path,
    name,
    icon: Icon,
    closeCollapse = () => {},
  } = props;
  const location = useLocation();
  const pathNameArray = location.pathname.split("/");
  const currentPath = pathNameArray[2];

  // Normalize name for data-cy attribute (remove spaces and special characters)
  const dataCyName = name.replace(/\s+/g, "");

  return (
    <NavLink
      to={layout + path}
      tag={NavLinkRRD}
      onClick={closeCollapse}
      className={`sidebar-option roboto-normal ${
        pathNameArray.includes(path.replace(/[^a-zA-Z ]/g, "")) ||
        activeRouteOptions.includes(currentPath)
          ? "active-sidebar"
          : ""
      }`}
      data-cy={`cy_${dataCyName}`}
    >
      <span className="sidebar-icon-container">
        <Icon style={{marginRight: "15px", fontSize: "20px"}} className="sidebar-icon" />
      </span>
      <span>{name}</span>
    </NavLink>
  );
};

NormalLink.propTypes = {
  layout: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  closeCollapse: PropTypes.func,
};

export default memo(NormalLink);
